import React from 'react';
import PropTypes from 'prop-types';
import styles from './IntroduccioIndividuFenofasesDetallComentari.module.css';
import { connect } from 'react-redux';
import { Input, Button } from 'antd';
import { Redirect } from 'react-router-dom';
import { VALOR_MAX_COMENTARI } from '../../constantsObservacions';
import {
  MISSATGE_CANVI_COMENTARI_TITOL,
  MISSATGE_COMENTARI_MAX_LENGTH,
  MISSATGE_COMENTARI_BUIT,
  MISSATGE_USUARI_NO_ACTIU,
} from '../../constantsFormularis';
import {
  fetchCrearComentari,
  fetchCanviComentari,
  fetchEsborrarComentari,
} from '../../actions/consultesServidor';
import { NotificacioError } from '../Notification';
import {
  obtenirDadesIntroduccio,
  esborrarComentaris,
  errorConsultaServidor,
} from '../../actions';
import { getUsuari } from '../../reducers';
import configuracio from '../../configuracioEntorns';

const { TextArea } = Input;

class IntroduccioIndividuFenofasesDetallComentari extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      comentari:
        props.observacioActual.idComentari &&
        props.observacioActual.textComentari
          ? props.observacioActual.textComentari
          : '',
      creacioComentariEnCurs: false,
      usuariNoActiu: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.observacioActual.esborrarComentaris) {
      this.setState({ comentari: '' });
      this.props.esborrarComentaris(
        nextProps.observacioActual.idIndividuFenofase,
        false
      );
    }
  }

  gestioUsuariNoActiu = (error) => {
    this.setState({ creacioComentariEnCurs: false, usuariNoActiu: true });
    this.props.errorConsultaServidor(error, MISSATGE_USUARI_NO_ACTIU);
  };

  gestioError = (error, titolTipus) => {
    if (error === MISSATGE_USUARI_NO_ACTIU) {
      this.gestioUsuariNoActiu(error);
    } else {
      this.gestioErrorPerTipus(error, titolTipus);
    }
  };

  gestioErrorPerTipus = (error, titolTipus) => {
    const { onDisableComponent } = this.props;
    this.setState({ creacioComentariEnCurs: false });
    onDisableComponent(false);
    this.props.errorConsultaServidor(error, titolTipus);
    this.props.obtenirDadesIntroduccio();
  };

  gestioExit = (comentari) => {
    const { onDisableComponent } = this.props;
    onDisableComponent(false);
    this.props.obtenirDadesIntroduccio();
    this.setState({ creacioComentariEnCurs: false });
    if (comentari && comentari.message && comentari.titol) {
      NotificacioError(comentari.titol, comentari.message);
    }
  };

  handleComentari = () => {
    const { observacioActual, onDisableComponent } = this.props;
    const idObservacio = observacioActual.idObservacion;
    const idComentari = observacioActual.idComentari;
    const textNou = this.state.comentari;

    if (!textNou || textNou.length === 0) {
      return NotificacioError(
        MISSATGE_CANVI_COMENTARI_TITOL,
        MISSATGE_COMENTARI_BUIT
      );
    }

    this.setState({ creacioComentariEnCurs: true });
    onDisableComponent(true);

    if (idComentari) {
      fetchCanviComentari(idComentari, textNou, this.props.usuari).then(
        (comentari) => {
          this.gestioExit(comentari);
        },
        (error) => {
          this.gestioError(error, 'Error canviant comentari.');
        }
      );
    } else {
      fetchCrearComentari(idObservacio, textNou, this.props.usuari).then(
        (idComentari) => {
          this.gestioExit(idComentari);
        },
        (error) => {
          this.gestioError(error, 'Error creant comentari.');
        }
      );
    }
  };

  esborrarComentari = () => {
    const { observacioActual } = this.props;
    const idComentari = observacioActual.idComentari;

    fetchEsborrarComentari(idComentari, this.props.usuari).then(
      (comentari) => {
        this.setState({ comentari: '' });
        this.gestioExit(comentari);
      },
      (error) => {
        this.gestioError(error, 'Error esborrant comentari.');
      }
    );
  };

  onChangeComentari = (event) => {
    const text = event.target.value;

    if (text.length > VALOR_MAX_COMENTARI) {
      return NotificacioError(
        MISSATGE_CANVI_COMENTARI_TITOL,
        `${MISSATGE_COMENTARI_MAX_LENGTH} ${VALOR_MAX_COMENTARI}`
      );
    }
    this.setState({ comentari: text });
  };

  // Render the child component and set the action property with the handler as value
  render() {
    const { observacioActual } = this.props;
    const { usuariNoActiu } = this.state;

    if (usuariNoActiu) {
      const urlBase = configuracio.ruta;
      return <Redirect to={`${urlBase}/login`} />;
    }

    if (
      !observacioActual.idObservacion ||
      !observacioActual.valorActual ||
      !observacioActual.mostrarComentari
    ) {
      return null;
    }

    const textDefecte = observacioActual.textComentari;
    const textMostrar = this.state.comentari;

    const inserirComentari = (
      <div
        className={
          styles.comentariIntroduccioSelectorImatgeContenidorImatgeAfegir
        }
        onClick={this.handleComentari}
      >
        <Button
          type="primary"
          htmlType="submit"
          size="small"
          disabled={this.state.creacioComentariEnCurs}
        >
          Guardar
        </Button>
      </div>
    );
    const esborrarComentari = (
      <div
        className={
          styles.comentariIntroduccioSelectorImatgeContenidorImatgeAfegir
        }
        onClick={this.esborrarComentari}
      >
        <Button
          type="primary"
          htmlType="submit"
          size="small"
          disabled={
            this.state.creacioComentariEnCurs ||
            !observacioActual.textComentari ||
            !observacioActual.idComentari
          }
        >
          Esborrar
        </Button>
      </div>
    );
    return (
      <div className={styles.comentariIntroduccio}>
        <div className={styles.comentariIntroduccioCamp}>
          <TextArea
            placeholder="Comentari"
            className={styles.comentariIntroduccioCamp}
            autoSize={{ minRows: 3, maxRows: 5 }}
            onChange={this.onChangeComentari}
            defaultValue={textDefecte}
            maxLength={VALOR_MAX_COMENTARI}
            value={textMostrar}
            disabled={this.state.creacioComentariEnCurs}
          />
        </div>
        {inserirComentari} {esborrarComentari}
      </div>
    );
  }
}

IntroduccioIndividuFenofasesDetallComentari.propTypes = {
  props: PropTypes.object,
  observacioActual: PropTypes.object.isRequired,
  obtenirDadesIntroduccio: PropTypes.func.isRequired,
  esborrarComentaris: PropTypes.func.isRequired,
  onDisableComponent: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func.isRequired,
  usuari: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    obtenirDadesIntroduccio,
    usuari: getUsuari(state),
  };
};

const mapDispatchToProps = {
  obtenirDadesIntroduccio,
  errorConsultaServidor,
  esborrarComentaris,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntroduccioIndividuFenofasesDetallComentari);
